import { c as _c } from "react/compiler-runtime";
import ActiveUserPlanColumn from 'modules/profile/user-plan/components/price-plan-columns/components/active-user-plan-column';
import UserPlanColumn from 'modules/profile/user-plan/components/price-plan-columns/components/user-plan-column';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UserPlanTypeEnum } from 'modules/profile/user-plan/enums/user-plan-type-enum';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { isOneClickAvailable, isPlanUpgradeAvailable, isUserPlanActive } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { twMerge } from 'tailwind-merge';
export interface PricePlanColumnsProps {
  currentUserPlanData: UseUserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  showWithTax: boolean;
}
const PricePlanColumns = t0 => {
  const $ = _c(21);
  const {
    currentUserPlanData,
    billingPeriod,
    showWithTax
  } = t0;
  let t1;
  if ($[0] !== currentUserPlanData.userPlan || $[1] !== currentUserPlanData.userPlans) {
    t1 = currentUserPlanData.userPlan && currentUserPlanData.userPlan.type === UserPlanTypeEnum.promotion ? [currentUserPlanData.userPlan, ...currentUserPlanData.userPlans] : currentUserPlanData.userPlans;
    $[0] = currentUserPlanData.userPlan;
    $[1] = currentUserPlanData.userPlans;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const calculatedUserPlans = t1;
  const isColumnsEnlarged = !!(currentUserPlanData.userPlan && currentUserPlanData.userPlan.type === UserPlanTypeEnum.automaticUpgrade);
  const t2 = currentUserPlanData.customer?.paymentMethod;
  let t3;
  if ($[3] !== t2) {
    t3 = isOneClickAvailable(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isOneClickUpgradeAvailable = t3;
  const t4 = isColumnsEnlarged ? "lg:grid-cols-[repeat(3,1fr)]" : "lg:grid-cols-[repeat(4,1fr)]";
  let t5;
  if ($[5] !== t4) {
    t5 = twMerge("lg:grid", t4, "sliderScroll sm:customScroll noScroll flex w-full flex-row items-center gap-6 overflow-y-hidden overflow-x-scroll px-2 pt-10 lg:overflow-hidden lg:px-6");
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== billingPeriod || $[8] !== calculatedUserPlans || $[9] !== currentUserPlanData || $[10] !== isOneClickUpgradeAvailable || $[11] !== showWithTax) {
    let t7;
    if ($[13] !== billingPeriod || $[14] !== currentUserPlanData || $[15] !== isOneClickUpgradeAvailable || $[16] !== showWithTax) {
      t7 = pricePlan => isUserPlanActive(pricePlan, currentUserPlanData, billingPeriod) ? <ActiveUserPlanColumn pricePlan={pricePlan} billingPeriod={billingPeriod} userRecourses={currentUserPlanData.userResources} key={pricePlan.id} showWithTax={showWithTax} /> : <UserPlanColumn pricePlan={pricePlan} billingPeriod={billingPeriod} key={pricePlan.id} isOneClickUpgradeAvailable={isOneClickUpgradeAvailable} paymentMethod={currentUserPlanData.customer?.paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable(pricePlan, billingPeriod, currentUserPlanData)} showWithTax={showWithTax} />;
      $[13] = billingPeriod;
      $[14] = currentUserPlanData;
      $[15] = isOneClickUpgradeAvailable;
      $[16] = showWithTax;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = calculatedUserPlans.map(t7);
    $[7] = billingPeriod;
    $[8] = calculatedUserPlans;
    $[9] = currentUserPlanData;
    $[10] = isOneClickUpgradeAvailable;
    $[11] = showWithTax;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default PricePlanColumns;